import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import CTAButtons from '../../OrderHistory/CTAButtons';
import { labelValuePairProp } from '../../../tools/customProps';
import { TmntText } from '../../Common';
import CancelRnEControls from './CancelRnEControls';

export default function RnEOrderDetailsCTAGroup({ ctaGroup }) {
  const originalOrder = ctaGroup.find(({ label }) => label?.key === 'RNE_RETURN_ORIGINALORDER');
  const detailsHref = originalOrder?.value;
  const detailsText = originalOrder?.label;

  return (
    <CTAButtons
      detailsHref={detailsHref}
      detailsText={detailsText ? <TmntText tmnt={detailsText} /> : null}
    >
      {ctaGroup.map((cta, index) => {
        // Skip rendering the Original Order button again
        if (cta.label?.key === 'RNE_RETURN_ORIGINALORDER') return null;

        const { label, value } = cta;
        const key = `${label?.key || 'cta'}_${index}`;

        // Render cancel RnE modal button
        if (value.includes('cancelRnEModal')) {
          const [,, orderNumber, email] = value.split(':');
          return (
            <CancelRnEControls
              email={email}
              key={key}
              label={label}
              orderNumber={orderNumber}
            />
          );
        }

        return (
          <Button
            key={key}
            onClick={() => window.open(cta.value, cta.label.key === 'GLB_TRACK_MY_RETURN' ? '_blank' : '')}
            variant="tertiary-light"
            isFullWidth
          >
            <TmntText tmnt={label} />
          </Button>
        );
      })}
    </CTAButtons>
  );
}

RnEOrderDetailsCTAGroup.defaultProps = {
  ctaGroup: [],
};

RnEOrderDetailsCTAGroup.propTypes = {
  ctaGroup: PropTypes.arrayOf(labelValuePairProp),
};
